(function () {
  if (window.__AG_PB_FAQ_INIT__) return;
  window.__AG_PB_FAQ_INIT__ = true;

  var TAB_MS = 260;
  var ACCORDION_MS = 340;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getTabs(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.js-ag-pb-faq-tab'));
  }

  function getPanels(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.js-ag-pb-faq-panel'));
  }

  function showPanel(panel) {
    if (!panel) return;
    panel.removeAttribute('hidden');
    panel.classList.add('is-active');
  }

  function hidePanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-active', 'is-entering', 'is-exiting');
    panel.setAttribute('hidden', '');
  }

  function activateTab(root, tab) {
    var tabs = getTabs(root);
    var panels = getPanels(root);
    if (!tab || tabs.length === 0) return;
    if (root._agFaqTabBusy) return;
    if (tab.classList.contains('is-active')) return;

    root._agFaqTabBusy = true;

    tabs.forEach(function (btn) {
      var active = btn === tab;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
      btn.tabIndex = active ? 0 : -1;
    });

    var panelId = tab.getAttribute('aria-controls');
    var next = panels.find(function (panel) {
      return panel.id === panelId;
    });
    var current = panels.find(function (panel) {
      return panel.classList.contains('is-active') && !panel.classList.contains('is-exiting');
    });

    if (!next || current === next) {
      root._agFaqTabBusy = false;
      return;
    }

    function enterNext() {
      if (current) hidePanel(current);
      showPanel(next);

      if (prefersReducedMotion()) {
        root._agFaqTabBusy = false;
        return;
      }

      next.classList.add('is-entering');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          next.classList.remove('is-entering');
          window.setTimeout(function () {
            root._agFaqTabBusy = false;
          }, TAB_MS);
        });
      });
    }

    if (!current || prefersReducedMotion()) {
      enterNext();
      return;
    }

    current.classList.add('is-exiting');
    current.classList.remove('is-active');
    window.setTimeout(enterNext, TAB_MS);
  }

  var pinToken = 0;

  function suppressPageScrollHandlers(ms) {
    window.__AG_SCROLL_SUPPRESS_UNTIL__ = Date.now() + (ms || ACCORDION_MS);
  }

  /**
   * Keep the question at the same viewport Y while section height changes.
   * Stops iOS/Safari scroll-anchoring from “scrolling up” on expand.
   */
  function pinElementViewportTop(el, topBefore, durationMs) {
    var token = ++pinToken;
    var start =
      typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();

    function correct() {
      if (!el || token !== pinToken) return;
      var drift = el.getBoundingClientRect().top - topBefore;
      if (drift > 0.5 || drift < -0.5) {
        window.scrollBy(0, drift);
      }
    }

    function frame(now) {
      if (token !== pinToken) return;
      correct();
      var t = typeof now === 'number' ? now : Date.now();
      if (t - start < durationMs) {
        window.requestAnimationFrame(frame);
      } else {
        correct();
      }
    }

    correct();
    window.requestAnimationFrame(frame);
  }

  function setItemOpen(item, open, options) {
    var instant = options && options.instant;
    var toggle = item.querySelector('.js-ag-pb-faq-toggle');
    var answer = item.querySelector('.ag-pb-faq__answer');

    if (instant) item.classList.add('is-instant');
    item.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (instant) {
      /* Force style flush so height snaps before we measure scroll drift */
      void item.offsetHeight;
      item.classList.remove('is-instant');
    }

    if (!answer) return;

    if (open) {
      answer.removeAttribute('hidden');
      return;
    }

    if (instant || prefersReducedMotion()) {
      answer.setAttribute('hidden', '');
      return;
    }

    window.setTimeout(function () {
      if (!item.classList.contains('is-open')) {
        answer.setAttribute('hidden', '');
      }
    }, ACCORDION_MS);
  }

  function toggleItem(root, item) {
    if (!item) return;
    var willOpen = !item.classList.contains('is-open');
    var pinEl = item.querySelector('.ag-pb-faq__question') || item;
    var topBefore = pinEl.getBoundingClientRect().top;
    var html = document.documentElement;
    var pinMs = prefersReducedMotion() ? 48 : ACCORDION_MS + 120;

    suppressPageScrollHandlers(pinMs + 40);
    html.classList.add('ag-pb-faq-scroll-stable');

    root.querySelectorAll('.js-ag-pb-faq-item.is-open').forEach(function (openItem) {
      if (openItem !== item) setItemOpen(openItem, false, { instant: true });
    });

    setItemOpen(item, willOpen);
    pinElementViewportTop(pinEl, topBefore, pinMs);

    window.setTimeout(function () {
      if (pinToken > 0) html.classList.remove('ag-pb-faq-scroll-stable');
    }, pinMs + 40);
  }

  function onTabKeydown(root, event, tab) {
    var tabs = getTabs(root);
    if (tabs.length === 0) return;

    var index = tabs.indexOf(tab);
    if (index < 0) return;

    var next = -1;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      next = (index + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      next = (index - 1 + tabs.length) % tabs.length;
    } else if (event.key === 'Home') {
      next = 0;
    } else if (event.key === 'End') {
      next = tabs.length - 1;
    }

    if (next < 0) return;
    event.preventDefault();
    tabs[next].focus();
    activateTab(root, tabs[next]);
  }

  function initBlock(root) {
    if (root.dataset.agPbFaqReady === 'true') return;
    root.dataset.agPbFaqReady = 'true';
    root._agFaqTabBusy = false;

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('.js-ag-pb-faq-tab');
      if (tab && root.contains(tab)) {
        activateTab(root, tab);
        return;
      }

      /* Whole card toggles; skip links / nested controls inside the answer */
      if (event.target.closest('a, input, textarea, select')) return;

      var card = event.target.closest('.ag-pb-faq__card');
      if (!card || !root.contains(card)) return;

      var item = card.closest('.js-ag-pb-faq-item');
      if (!item) return;

      event.preventDefault();
      /* Blur focused control — iOS scroll-into-view on focus causes viewport shake */
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        if (card.contains(document.activeElement)) document.activeElement.blur();
      }
      toggleItem(root, item);
    });

    root.addEventListener('keydown', function (event) {
      var tab = event.target.closest('.js-ag-pb-faq-tab');
      if (!tab || !root.contains(tab)) return;
      onTabKeydown(root, event, tab);
    });

    root.querySelectorAll('.js-ag-pb-faq-item').forEach(function (item) {
      setItemOpen(item, false);
    });
  }

  function initAll(scope) {
    var rootEl = scope && scope.querySelectorAll ? scope : document;
    rootEl.querySelectorAll('.js-ag-pb-faq').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll('.js-ag-pb-faq').forEach(function (root) {
      root.dataset.agPbFaqReady = '';
      initBlock(root);
    });
  });
})();
